import baseService from './baseService'

export const userService = {
  login
}

function login (username, password) {
  return baseService.postRequest('users/authenticate', { username: username, password: password })
}
